module.exports = "<p>\r\n  event-modal works!\r\n</p>\r\n"